import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationDE from '../locales/de/tranlation.json';
import translationEN from '../locales/en/tranlation.json';

i18n.use(initReactI18next).init({
  resources: {
    de: {
      translation: translationDE,
    },
    en: {
      translation: translationEN,
    },
  },
  lng: 'de', // Standardsprache
  fallbackLng: 'en', // Wenn eine Übersetzung fehlt, auf Englisch zurückfallen
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
